import { deserialize } from 'cerialize'

export class ActUnpaidModel {
	@deserialize public id: number
	@deserialize public name?: string
	@deserialize public nepal_act_amount_of_remuneration?: number
	@deserialize public vat_number?: string
	@deserialize public nepal_act_count?: number
}
